(function (ws) {
    'use strict';

    ws.models.addProductsToQuote = Backbone.Model.extend({
        urlRoot: globals.path.api.quoting.productTableAddToQuoteUrl,
        defaults: {
            productList: ['WestconTest1', 'WestconTest2']
        }
    });

})(westcon);
